const __WEBPACK_NAMESPACE_OBJECT__ = require("@ledgerhq/hw-app-eth");